import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import Project from '../../../domain/entity/Project';
import { ProjectTypeLabel } from '../ProjectTypeLabel';
import VariationQuota from '../VariationQuota';
import config from '../../../config';

interface IProps {
  project: Project;
}

const Wrapper = styled.div`
  background-color: ${colors.mochi__f2f6fa};
  padding: 8px 12px 16px;
`;

const SubHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
`;

const ProjectId = styled.div`
  display: inline-block;
  font-size: 12px;
  color: ${colors.ash__b4bed5};
  margin-right: 8px;
`;

const ProjectTitle = styled.a`
  font-size: 14px;
  font-weight: 700;
  color: currentColor;
`;

export class RoundMonitorProjectOverview extends React.Component<IProps, {}> {
  public render() {
    const { project } = this.props;
    return (
      <Wrapper>
        <SubHeading>
          <ProjectTypeLabel label={project.productTypeLabel()} color={project.productTypeColor()} />
          <VariationQuota project={project} />
        </SubHeading>
        <Heading>
          <ProjectId>#{project.id}</ProjectId>
          <ProjectTitle
            href={`${config.dashboard}/experiments/${project.id}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            {project.title}
          </ProjectTitle>
        </Heading>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundMonitor/RoundMonitorProjectOverview.tsx